import type { ThemeConfig } from './types';

export const defaultTheme: ThemeConfig = {
  id: 'default',
  name: 'Default',
  canvasBackground: '#1a1a2e',
  levelStyles: [
    {
      // Root node
      backgroundColor: '#6366f1',
      textColor: '#ffffff',
      fontSize: 18,
      fontWeight: 'bold',
      borderRadius: 12,
      paddingX: 24,
      paddingY: 14,
    },
    {
      // Level 1
      backgroundColor: '#3b82f6',
      textColor: '#ffffff',
      fontSize: 15,
      fontWeight: '600',
      borderRadius: 8,
      paddingX: 16,
      paddingY: 10,
    },
    {
      // Level 2+
      backgroundColor: '#334155',
      textColor: '#e2e8f0',
      fontSize: 14,
      fontWeight: 'normal',
      borderRadius: 6,
      paddingX: 14,
      paddingY: 8,
    },
  ],
  connectorStyle: {
    color: '#475569',
    width: 2,
  },
  selectionColor: '#f59e0b',
  searchHighlightColor: '#22c55e',
};

export function getStyleForLevel(theme: ThemeConfig, depth: number) {
  if (depth < theme.levelStyles.length) {
    return theme.levelStyles[depth]!;
  }
  return theme.levelStyles[theme.levelStyles.length - 1]!;
}
